import React, { memo } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { getLocale } from "@I18n/services/i18n";
import { ShieldCheckSolid } from "@UI/Components/Icons/ShieldCheck";
import { IExtendedMetric } from "@modules/ServiceProviders/types/serviceProvider.types";
import { MetricCard } from "../MetricCard";
import { MetricIconStatus } from "../MetricIconStatus";
import messages from "../messages";

interface IVerifiedCard {
  metric: IExtendedMetric | undefined;
  onClick?: () => void;
}

export const VerifiedCard = memo(({ metric, onClick }: IVerifiedCard) => {
  const reached =
    metric !== undefined &&
    metric.value !== null &&
    metric.threshold !== null &&
    Number(metric.value) >= Number(metric.threshold);

  const kycAt = metric?.computationDetails?.kycAt;
  const kycDate = kycAt
    ? new Date(kycAt).toLocaleDateString(getLocale(), {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    : undefined;
  const rejected = !reached && metric?.computationDetails?.kycStatus === "refused";

  return (
    <MetricCard
      title={<FormattedMessage {...messages.verifiedTitle} />}
      onClick={onClick}
      description={<FormattedMessage {...messages.verifiedDescription} />}
      state={reached ? "reached" : rejected ? "rejected" : "not-reached"}
    >
      <MetricIconStatus
        icon={ShieldCheckSolid}
        state={reached ? "success" : rejected ? "error" : "default"}
        message={
          rejected ? (
            <FormattedMessage {...messages.verifiedStatusRejected} />
          ) : (
            <>
              <FormattedMessage
                {...(reached ? messages.verifiedStatusReached : messages.verifiedStatus)}
              />
              {reached && kycDate && (
                <>
                  <br />
                  {kycDate}
                </>
              )}
            </>
          )
        }
      />
    </MetricCard>
  );
});

VerifiedCard.displayName = "VerifiedCard";
